import React from 'react'
import formatters from 'lib/formatters'
import AccordionStylingExpansion from 'components/Accordion/Accordion'

import styles from './styles.css'

const AssetServicesAccordion = ({ asset }) => {
  if (!asset || !asset.services) return null

  const getServiceAccordionData = () => {
    const services = asset.services
    const accordionItems = []

    const taxService = services.find((s) => s.service_type === 'tax')
    if (taxService && taxService.events) {
      const taxEvents = taxService.events.sort((a, b) => new Date(b.date) - new Date(a.date))

      const lastPaid = taxEvents[0]?.date
      const taxContent = (
        <div>
          {taxEvents.slice(0, 3).map((event, idx) => (
            <div key={idx} className={styles.singleLine}>
              <div className={styles.label}>{formatters.date(event.date)}</div>
              <div className={styles.label}>{formatters.money(event.amount)}</div>
            </div>
          ))}
        </div>
      )

      accordionItems.push({
        title: 'Taxes',
        details: taxContent,
        subtitle: lastPaid ? `Last paid: ${formatters.date(lastPaid)}` : null,
      })
    }

    const homeInsurance = services.find((s) => s.service_type === 'home_insurance')
    if (homeInsurance) {
      const coverageString =
        homeInsurance.coverage_start && homeInsurance.coverage_end
          ? `Coverage: ${formatters.date(homeInsurance.coverage_start)} - ${formatters.date(homeInsurance.coverage_end)}`
          : null

      const homeInsuranceContent = (
        <div>
          <div className={styles.singleLine}>
            <div className={styles.label}>Provider</div>
            <div className={styles.label}>{homeInsurance.provider || 'N/A'}</div>
          </div>
          {homeInsurance.coverage_start && homeInsurance.coverage_end && (
            <div className={styles.singleLine}>
              <div className={styles.label}>Latest Coverage</div>
              <div className={styles.label}>
                {formatters.date(homeInsurance.coverage_start)} - {formatters.date(homeInsurance.coverage_end)}
              </div>
            </div>
          )}
          {homeInsurance.cost && (
            <div className={styles.singleLine}>
              <div className={styles.label}>Cost</div>
              <div className={styles.label}>{formatters.money(homeInsurance.cost)}, annually</div>
            </div>
          )}
        </div>
      )

      accordionItems.push({
        title: 'Home Insurance',
        details: homeInsuranceContent,
        subtitle: coverageString,
      })
    }

    const floodInsurance = services.find((s) => s.service_type === 'flood_insurance')
    if (floodInsurance) {
      const coverageString =
        floodInsurance.coverage_start && floodInsurance.coverage_end
          ? `Coverage: ${formatters.date(floodInsurance.coverage_start)} - ${formatters.date(floodInsurance.coverage_end)}`
          : null

      const floodInsuranceContent = (
        <div>
          <div className={styles.singleLine}>
            <div className={styles.label}>Provider</div>
            <div className={styles.label}>{floodInsurance.provider || 'N/A'}</div>
          </div>
          {floodInsurance.coverage_start && floodInsurance.coverage_end && (
            <div className={styles.singleLine}>
              <div className={styles.label}>Coverage Dates</div>
              <div className={styles.label}>
                {formatters.date(floodInsurance.coverage_start)} - {formatters.date(floodInsurance.coverage_end)}
              </div>
            </div>
          )}
          {floodInsurance.cost && (
            <div className={styles.singleLine}>
              <div className={styles.label}>Cost</div>
              <div className={styles.label}>{formatters.money(floodInsurance.cost)}, annually</div>
            </div>
          )}
        </div>
      )

      accordionItems.push({
        title: 'Flood Insurance',
        details: floodInsuranceContent,
        subtitle: coverageString,
      })
    }

    const homeInspection = services.find((s) => s.service_type === 'home_inspection')
    if (homeInspection && homeInspection.events) {
      const lastInspection = homeInspection.events.sort((a, b) => new Date(b.date) - new Date(a.date))[0]

      const inspectionContent = (
        <div>
          <div className={styles.singleLine}>
            <div className={styles.label}>Provider</div>
            <div className={styles.label}>{homeInspection.provider || 'N/A'}</div>
          </div>
          {lastInspection && (
            <div className={styles.singleLine}>
              <div className={styles.label}>Last Inspection</div>
              <div className={styles.label}>{formatters.date(lastInspection.date)}</div>
            </div>
          )}
        </div>
      )

      accordionItems.push({
        title: 'Inspection',
        details: inspectionContent,
        subtitle: lastInspection ? `Last Inspection: ${formatters.date(lastInspection.date)}` : null,
      })
    }
    const appraisal = services.find((s) => s.service_type === 'appraisal')
    if (appraisal && appraisal.events) {
      const lastAppraisal = appraisal.events.sort((a, b) => new Date(b.date) - new Date(a.date))[0]

      const appraisalContent = (
        <div>
          <div className={styles.singleLine}>
            <div className={styles.label}>Provider</div>
            <div className={styles.label}>{appraisal.provider || 'N/A'}</div>
          </div>
          {lastAppraisal && (
            <div className={styles.singleLine}>
              <div className={styles.label}>Last Appraisal</div>
              <div className={styles.label}>{formatters.date(lastAppraisal.date)}</div>
            </div>
          )}
        </div>
      )

      accordionItems.push({
        title: 'Appraisal',
        details: appraisalContent,
        subtitle: lastAppraisal ? `Last Appraisal: ${formatters.date(lastAppraisal.date)}` : null,
      })
    }

    return accordionItems
  }

  const accordionItems = getServiceAccordionData()

  if (accordionItems.length === 0) return null

  return (
    <div className={styles.accordionContainer}>
      <AccordionStylingExpansion items={accordionItems} />
    </div>
  )
}

export default AssetServicesAccordion
